/**
 * AskAsper configuration
 * Base URL for AskAsper 2 API - set via VITE_ASK_ASPER_BASE_URL env variable
 */
export const ASK_ASPER_BASE_URL = 'https://demo1-backend.asper.revenuegrowth.ai/askasper/';
